import { z } from 'my-zod'
import { vehiclesModel } from './vehicles-model'
import { modelFamiliesModel } from '../model-family'
import { vehicleUseHistoryModel } from '../../outfitter-operations/vehicle-use-history'

export const checkedOutVehicleView = z.object({
  id: vehicleUseHistoryModel.shape.id,
  vehicleId: vehiclesModel.shape.id,
  vehicleVin: vehiclesModel.shape.vin,
  vehicleModelFamily: modelFamiliesModel.shape.modelFamilyName.nullable(),
  vehicleLifecycleStatus: vehiclesModel.shape.lifecycleStatus,
  programType: vehiclesModel.shape.programType,
  outfitterId: vehicleUseHistoryModel.shape.operatorId,
  checkOutDate: vehicleUseHistoryModel.shape.checkOutDateTime,
  primaryCustomerId: z.string().uuid().nullable(),
  customerWaiverId: vehicleUseHistoryModel.shape.customerWaiverId
})

export type checkedOutVehicleView = z.infer<typeof checkedOutVehicleView>
